import * as Backbone from "backbone";
import { CachingCollection } from "./_BaseCollection";

interface ReportsCollectionOptions {
    orgId?: number;
}

export class ReportsCollection extends CachingCollection<Backbone.Model> {
    public orgId: number;

    constructor(initialModels?: Object[] | any[], options?: ReportsCollectionOptions) {
        super(initialModels, options);

        this.orgId = options ? options.orgId : null;
    }

    url = () => {
        return window.location.origin + "/api/v1/reports" + (this.orgId ? `/${this.orgId}` : "");
    };

    cloneUrl = (reportId) => {
        return `${window.location.origin}/api/v1/reports/${reportId}/clone`;
    };

    comparator = (model) => {
        return model.get("name");
    };
}



// WEBPACK FOOTER //
// ./srv/public/js/collections/Reports.ts